"use strict";
const template = require("./visualizerTemplate");
function makeVisualizerPage(options = {}) {
  const {
    cdn = "https://www.lactame.com/visualizer",
    fallbackVersion = "latest",
    scripts = []
  } = options;
  const scriptsStr = scripts.reduce(function(value, script) {
    if (script.url) {
      return value + `<script src="${script.url}"><\/script>
`;
    } else if (script.content) {
      return value + `<script>${script.content}<\/script>
`;
    } else {
      throw new Error("script must have url or content");
    }
  }, "");
  return template.replaceAll("{{ cdn }}", cdn).replaceAll("{{ fallbackVersion }}", fallbackVersion).replace("{{ scripts }}", scriptsStr);
}
module.exports = makeVisualizerPage;
